import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getApi } from '../../services/apiServices';
import { toast } from 'react-toastify';

function ViewBlog() {
    const { blog_id } = useParams();
    const navigate = useNavigate();
    const [blogData, setBlogData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBlogDetails = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await getApi(`/api/blogs/${blog_id}`, { showSuccessToast: false });

            if (response?.status) {
                setBlogData(response.data?.blog || response.data);
            } else {
                setError(response?.message || 'Failed to fetch blog details');
                toast.error(response?.message || 'Failed to fetch blog details');
            }
        } catch (error) {
            console.error('Error fetching blog details:', error);
            setError('Failed to fetch blog details. Please try again.');
            toast.error('Failed to fetch blog details. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (error) {
            return dateString;
        }
    };

    const handleBackClick = () => {
        navigate('/admin/blogs');
    };

    const handleEditClick = () => {
    
        navigate('/admin/blogs');
        toast.info('Edit functionality is available in the blogs list');
    };

    useEffect(() => {
        if (blog_id) {
            fetchBlogDetails();
        }
    }, [blog_id]);

    return (
        <div className="right-section view-blog">
            <div className="customer-top">
                <div className="customer-top-left">
                    <button 
                        onClick={handleBackClick} 
                        className="btn add-btns"
                    >
                        ← Back to Blogs
                    </button>
                    {/* <h2>Blog Details</h2> */}
                </div>
               
            </div>

            <div className="customer-tablle-main">
                {loading ? (
                    <div className="loader-overlay">
                        <span className="loader"></span>
                    </div>
                )  : blogData ? (
                        <div className="row p-3">
                            {/* Blog Image */}
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className='d-block'>Blog Image</label>
                                    <span className='blog-imgae'>
                                    {blogData.image_full_url ? (
                                        <img 
                                            src={blogData.image_full_url} 
                                            alt={blogData.title} 
                                            className="img-fluid"
                                            style={{ 
                                                width: '100%', 
                                                height: '100%',
                                                borderRadius: '8px'
                                            }}
                                        />
                                        
                                    ) : (
                                        <div className="text-muted">
                                            <p>No image uploaded</p>
                                        </div>
                                    )}
                                    </span>
                                </div>
                            </div>

                            {/* Blog Information */}
                            <div className="col-md-8">
                                <div className='row'>
                                    <div className='col-md-6'>
                                                <div className="form-group">
                                                <label>Title</label>
                                                <p className="form-control-static">{blogData.title || 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                              <div className="form-group">
                                            <label>Author</label>
                                            <p className="form-control-static">{blogData.author || 'N/A'}</p>
                                        </div>
                                        </div>
                                              <div className='col-md-6'>
                                              <div className="form-group">
                                                <label>Status</label>
                                                <p className="form-control-static">
                                                    <span className={`status-badge ${blogData.status ? 'active' : 'inactive'}`}>
                                                        {blogData.status ? 'Active' : 'Inactive'}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                              <div className='col-md-6'>
                                              <div className="form-group">
                                                <label>Created At</label>
                                                <p className="form-control-static">{formatDate(blogData.created_at)}</p>
                                            </div>
                                        </div>
                                              <div className='col-md-6'>
                                                <div className="form-group">
                                                <label>Updated At</label>
                                                <p className="form-control-static">{formatDate(blogData.updated_at)}</p>
                                            </div>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className="form-group">
                                    <label>Description</label>
                                    <div 
                                        className="form-control-static" 
                                                style={{ 
                                                    border: '1px solid #ddd',
                                                    padding: '15px',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#f9f9f9',
                                                    minHeight: '200px',
                                                    maxHeight: '400px',
                                                    overflowY: 'auto'
                                                }}
                                                dangerouslySetInnerHTML={{ __html: blogData.description || 'No description available' }}
                                            />
                                        </div>
                                     </div>
                                    </div>    
                            </div>
                        </div>
                ) : (
                    <div className="no-data text-center">
                        <p>Blog not found.</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ViewBlog; 